import React, { useRef, useEffect, memo } from "react";
import { useDispatch } from 'react-redux'
import { removeMatchingPairsOptionImage, removeMatchingPairsPair, setMatchingPairsImageUrl, updateMatchingPairsFlip, updateMatchingPairsOption } from '../../../../../redux/slices/userActivity'
import Card from "./card";

function Pair({ idx, id, l_option, r_option, l_image_data, r_image_data, l_flipped, r_flipped, isDummy, addPair, matchingpair_set, l_image, r_image, l_image_url, r_image_url }) {

   const dispatch = useDispatch()
   //add isflipped properties to check if card is flipped
   const leftInputRef = useRef(null);
   const rightInputRef = useRef(null);

   const updateFlip = (l_flipped, r_flipped) => {
      dispatch(updateMatchingPairsFlip({
         selectedOption: id,
         l_flipped: l_flipped,
         r_flipped: r_flipped
      }))
   }

   useEffect(() => {
      if(isDummy) return
      if(l_image !== null){
         if(l_image_url !== null) return
         let image_url = { l_image_url: l_image }
         dispatch(setMatchingPairsImageUrl({id, image_url}))
      }
      if(l_image_url !== null){
         if(l_image !== null) return
          let image_url = { l_image: l_image_url }
         dispatch(setMatchingPairsImageUrl({id, image_url}))
      }
      if(r_image !== null){
         if(r_image_url !== null) return
         let image_url = { r_image_url: r_image }
         dispatch(setMatchingPairsImageUrl({id, image_url}))
      }
      if(r_image_url !== null){
         if(r_image !== null) return
         let image_url = { r_image: r_image_url }
         dispatch(setMatchingPairsImageUrl({id, image_url}))
      }
   }, [])

   const handleTextChange = (updatedOption) => {
      dispatch(updateMatchingPairsOption({
         selectedOption: id,
         updatedOption
      }))
   }
   const removePair = () => {
      if(matchingpair_set.length < 3 ) return
      dispatch(removeMatchingPairsPair({id}))
   }

   const updateOptionImage = (e, { isLeft }) => {
      var reader = new FileReader();
      reader.onloadend = function () {
         if (isLeft) {
            dispatch(updateMatchingPairsOption({
               selectedOption: id,
               updatedOption: {
                  l_image_data: {
                     name: e.target.files[0].name,
                     uri: reader.result,
                  },
                  l_option: null
               }
            }))
            return
         } else {
            dispatch(updateMatchingPairsOption({
               selectedOption: id,
               updatedOption: {
                  r_image_data: {
                     name: e.target.files[0].name,
                     uri: reader.result,
                  },
                  r_option: null
               }
            }))
         }
      };
      reader.readAsDataURL(e.target.files[0]);
   }

   const removeOptionImage = ({ isLeft }) => {
      if (isLeft) {
         dispatch(removeMatchingPairsOptionImage({
            selectedOption: id,
            image_data: 'l_image_data',
            option: 'l_option'
         }))
         return
      } else {
         dispatch(removeMatchingPairsOptionImage({
            selectedOption: id,
            image_data: 'r_image_data',
            option: 'r_option'
         }))
      }
   }

   return (
      <div className='single-pair'>
         <div className='single-pair-header' onClick={() => isDummy ? addPair() : null} >
           <p >
            {
               isDummy ? <>
               <img src="/assets/icons/add-pair.svg" className="add-pair-icon" /> Add pair
               </> :
               `Pair${idx + 1}`
            }
            </p>

            <div className="header-remove-btn"
               onClick={() => removePair()}
            >
               <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 16 16" fill="#fff">
                  <path
                     d="M15.3812 3.04103C15.8923 2.52988 15.8923 1.70115 15.3812 1.19C14.8701 0.678854 14.0413 0.678854 13.5302 1.19L8.28561 6.43457L3.04104 1.19C2.5299 0.678855 1.70116 0.678854 1.19002 1.19C0.67887 1.70115 0.678871 2.52988 1.19002 3.04103L6.43458 8.28559L1.19 13.5302C0.678854 14.0413 0.678854 14.8701 1.19 15.3812C1.70115 15.8923 2.52988 15.8923 3.04103 15.3812L8.28561 10.1366L13.5302 15.3812C14.0413 15.8924 14.8701 15.8924 15.3812 15.3812C15.8924 14.8701 15.8924 14.0413 15.3812 13.5302L10.1366 8.28559L15.3812 3.04103Z"
                     fill="#ffffff94"
                  />
               </svg>
            </div>
         </div>
         <div className='pair-cards'>

            <Card isLeft={true}
               isFlipped={l_flipped}
               updateFlip={updateFlip}
               r_flipped={r_flipped}
               l_flipped={l_flipped}
               option={l_option}
               inputRef={leftInputRef}
               handleTextChange={handleTextChange}
               default_image_url={l_image}
               updateOptionImage={updateOptionImage}
               image={l_image_data}
               removeOptionImage={removeOptionImage} />

            <Card isLeft={false}
               isFlipped={r_flipped}
               updateFlip={updateFlip}
               r_flipped={r_flipped}
               l_flipped={l_flipped}
               option={r_option}
               inputRef={rightInputRef}
               handleTextChange={handleTextChange}
               default_image_url={r_image}
               updateOptionImage={updateOptionImage}
               image={r_image_data}
               removeOptionImage={removeOptionImage} />

         </div>

      </div>
   )
}

export default memo(Pair)